function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "30px",
    width: "30px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#21D0C3"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#15BDB2"
    },
    cx: 256,
    cy: 421.636,
    rx: 182.284,
    ry: 14.37
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M65.982,67.222h380.037c12.486,0,22.701,10.216,22.701,22.702V324.03H43.281V89.923 C43.281,77.439,53.497,67.222,65.982,67.222L65.982,67.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M58.695,308.616h394.609V89.923c0-3.978-3.309-7.287-7.286-7.287H65.981 c-3.977,0-7.286,3.309-7.286,7.287V308.616L58.695,308.616z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.719,324.03v24.828c0,12.488-11.259,22.702-25.025,22.702H68.306 c-13.764,0-25.025-10.214-25.025-22.702V324.03H468.719L468.719,324.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M149.561,108.344h212.877h31.688c3.84,0,6.981,3.144,6.981,6.981v41.547v151.744H110.891 l-0.001-0.002V156.874v-41.548c0-3.84,3.142-6.981,6.981-6.981C117.872,108.344,149.561,108.344,149.561,108.344z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282"
    },
    d: "M117.872,108.344h276.255c3.84,0,6.981,3.142,6.981,6.981v13.962H110.89v-13.962 C110.89,111.485,114.031,108.344,117.872,108.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240.094,115.575h140.19c1.033,0,1.875,0.842,1.875,1.875v3.479c0,1.033-0.842,1.875-1.875,1.875 h-140.19c-1.033,0-1.875-0.842-1.875-1.875v-3.479C238.219,116.419,239.062,115.575,240.094,115.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M124.817,114.331c2.219,0,4.019,1.797,4.019,4.019c0,2.221-1.801,4.019-4.019,4.019 c-2.222,0-4.023-1.798-4.023-4.019C120.794,116.128,122.595,114.331,124.817,114.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M140.684,114.331c2.222,0,4.019,1.797,4.019,4.019c0,2.221-1.797,4.019-4.019,4.019 c-2.22,0-4.019-1.798-4.019-4.019C136.664,116.128,138.465,114.331,140.684,114.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M156.555,114.331c2.219,0,4.018,1.797,4.018,4.019c0,2.221-1.799,4.019-4.018,4.019 c-2.223,0-4.023-1.798-4.023-4.019C152.532,116.128,154.332,114.331,156.555,114.331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M126.598,136.965h258.805v85.375H126.598V136.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M164.995,234.807c9.502,0,17.204,7.702,17.204,17.204c0,9.5-7.702,17.204-17.204,17.204 c-9.5,0-17.202-7.703-17.202-17.204C147.792,242.509,155.494,234.807,164.995,234.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M256,234.807c9.5,0,17.202,7.702,17.202,17.204c0,9.5-7.702,17.204-17.202,17.204 c-9.5,0-17.202-7.703-17.202-17.204C238.797,242.509,246.499,234.807,256,234.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M347.004,234.807c9.5,0,17.202,7.702,17.202,17.204c0,9.5-7.702,17.204-17.202,17.204 c-9.502,0-17.204-7.703-17.204-17.204C329.8,242.509,337.502,234.807,347.004,234.807z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M140.311,274.951h49.37v2.677h-49.37V274.951z M140.311,291.781h33.16v2.677h-33.16L140.311,291.781 L140.311,291.781z M140.311,283.366h49.37v2.676h-49.37V283.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M231.315,274.951h49.369v2.677h-49.369V274.951z M231.315,291.781h33.162v2.677h-33.162 L231.315,291.781L231.315,291.781z M231.315,283.366h49.369v2.676h-49.369V283.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M322.322,274.951h49.367v2.677h-49.367V274.951z M322.322,291.781h33.159v2.677h-33.159V291.781z  M322.322,283.366h49.367v2.676h-49.367V283.366z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M125.309,227.791h260.093v1.073H125.309V227.791z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 256,
    cy: 346.803,
    r: 7.815
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C4"
    },
    d: "M305.065,407.272l36.096,11.566H170.836l29.124-11.566v-35.713h105.105V407.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B0B0B0"
    },
    d: "M305.065,407.272L199.96,371.558h105.105V407.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M199.96,407.272h105.105l36.096,11.566v4.981H256h-85.164v-4.981L199.96,407.272L199.96,407.272z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer1);
export default __webpack_public_path__ + "static/media/computer1.708a47ec4d7fa3aad99dc6203c3aba9b.svg";
export { ForwardRef as ReactComponent };